/**
 * Browser download helpers for overview exports.
 *
 * Deliberately a local copy of the preflight equivalent (`features/preflight/lib/download.ts`)
 * rather than a shared import — the two features stay decoupled, and neither owns a util
 * the other depends on.
 */

/** Trigger a browser download for a Blob via a transient object URL. */
function downloadBlobAs(blob: Blob, filename: string): void {
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement("a");
  anchor.href = url;
  anchor.download = filename;
  document.body.appendChild(anchor);
  anchor.click();
  anchor.remove();
  URL.revokeObjectURL(url);
}

/** Trigger a download for string content (csv, json, plain text, …). */
export function downloadText(content: string, filename: string, mime: string): void {
  downloadBlobAs(new Blob([content], { type: mime }), filename);
}
